import styles from './AppShell.module.css'

interface AppShellProps {
  header?: React.ReactNode
  children: React.ReactNode
  footer?: React.ReactNode
}

export default function AppShell({ header, children, footer }: AppShellProps) {
  return (
    <div className={styles.shell}>
      <div className={styles.scroll}>
        {header}
        <div className={styles.body}>{children}</div>
      </div>
      {footer}
    </div>
  )
}
